import { NoData } from "../constants";
import { useTranslation } from '../i18n/useTranslation';

export const NoStores = ({ onBack }) => {
  const { t } = useTranslation();
  return (
    <div
      style={{
        position: "fixed",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        background: "#fff",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection:'column',
        zIndex:9
      }}
    >
      <img src={NoData} style={{ width: 100, height: 100 }} alt="loader" />
      <span style={{display:'block',width:'80%', textAlign:'center', marginTop:20}}>
        {t('no_stores_found')}
      </span>
      {onBack && (
        <button
          onClick={onBack}
          style={{
            marginTop: 20,
            padding: '10px 30px',
            background: '#2585c3',
            color: '#fff',
            border: 'none',
            borderRadius: 5,
            fontSize: 14,
            cursor: 'pointer',
          }}
        >
          {t('back') || 'Back'}
        </button>
      )}
    </div>
  );
};
